export enum NavigationMode {
  Querystring = 1,
  Backend = 2,
}
